/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
import React from "react";
// Redux Toolkit
import { useSelector } from "react-redux";
import { selectUser } from "../../../store/userSlice";
// BASE Components
import BASESvgIcon from "../../../../@BASE/core/BASESvgIcon"
import NavLinkAdapter from "../../../../@BASE/core/NavLinkAdapter";
import authRoles from "../../../auth/authRoles";
// Material UI
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button"

const ChildListingHeader = (props) => {
  const { resource, subtitle, parent } = props;
  const user = useSelector(selectUser);

  return (
    <Box className="flex items-center px-0 w-full min-h-36">
      <Typography className="grow text-20 font-bold tracking-tight leading-none">
        {resource.charAt(0).toUpperCase() + resource.slice(1)} {subtitle ? `(${subtitle})` : null}
      </Typography>
      {((resource === "pages" && authRoles.editor.includes(user.role)) || authRoles.leadEditor.includes(user.role)) && (
        <Button
          variant="contained"
          color="secondary"
          component={NavLinkAdapter}
          to={`/${resource}/new/edit?p=${parent}`}
          startIcon={<BASESvgIcon size={20}>heroicons-outline:plus</BASESvgIcon>}
        >
          Add
        </Button>
      )}
    </Box>
  )
}

export default ChildListingHeader;